import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, Box, IconButton } from '@mui/material';
import CustomDivider from '../../utils/CustomDivider';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const TabsComponent = ({ tabs, value, onChange }) => {
    const handleNextTab = () => {
        const nextIndex = (value + 1) % tabs.length;
        onChange(null, nextIndex);
    };
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                }}>
                <Tabs
                    value={value}
                    onChange={onChange}
                    indicatorColor="transparent"
                    variant="scrollable"
                    scrollButtons="none"

                    sx={{
                        "& .MuiTabs-flexContainer": {
                            flexWrap: "nowrap",
                        },
                        flexGrow: 1,
                        overflowX: "auto",
                        position: "relative"
                        // "& .MuiTabs-flexContainer": {
                        //     flexWrap: "wrap",
                        // },
                    }}
                >
                    {tabs.map((item, index) => (
                        <Tab
                            key={index}
                            sx={{
                                minWidth: { sm: "70px", xs: "auto" },
                                borderBottom: value === index ? "4px solid #4169E1" : "none",
                                background: value === index
                                    ? "linear-gradient(175.34deg, #FFFFFF 18.63%, #4169E1 140.9%)"
                                    : "primary.light",
                            }}
                            label={
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: value === index ? 'blue.main' : 'text.primary',
                                        fontWeight: 500,
                                        textTransform: "capitalize",
                                    }}
                                >
                                    {item.label}
                                </Typography>
                            }
                        />
                    ))}


                </Tabs>

                {tabs.length > 1 && (
                    <IconButton
                        sx={{
                            ml: 2,
                            bgcolor: "#C9D6FE",
                            '&:hover': {
                                bgcolor: "#B0C4FF",
                            }
                        }}
                        onClick={handleNextTab}
                        aria-label="Next Tab"
                    >
                        <ArrowForwardIosIcon sx={{ fontSize: "15px" }} />
                    </IconButton>
                )}
            </Box>
            <CustomDivider size={"0px"} sx={{ borderBottom: "2px solid #E8E8E8", mb: 2 }} />
        </>

    );
};

TabsComponent.propTypes = {
    tabs: PropTypes.array.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default TabsComponent;
